import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import seoData from '../seo/home.json';
import './Home.css';

const highlights = [
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
    ),
    title: 'Tax Management',
    desc: 'Strategic tax planning and preparation to minimize liabilities and maximize your cash flow.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
    ),
    title: 'Accounting Services',
    desc: 'Accurate record-keeping, financial statements, and reporting to drive profitability.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
    ),
    title: 'Payroll Services',
    desc: 'Streamlined payroll processing, tax return preparation, and employee management.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    ),
    title: 'Audit Assistance',
    desc: 'Professional guidance through audits and financial statement assurance services.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
    ),
    title: 'Financial Planning',
    desc: 'Comprehensive retirement, investment, and estate planning for your financial future.',
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
    ),
    title: 'Business Consulting',
    desc: 'Valuations, mergers, entity structuring, and strategic business guidance.',
  },
];

const stats = [
  { number: '30+', label: 'Years Experience' },
  { number: '1000+', label: 'Clients Served' },
  { number: '20+', label: 'Services Offered' },
  { number: '100%', label: 'Dedication' },
];

export default function Home() {
  return (
    <>
      <SEOHead seo={seoData} />

      {/* ===== HERO ===== */}
      <section className="hero">
        <div className="hero__bg" />
        <div className="hero__content container">
          <div className="hero__text">
            <span className="hero__badge fade-in-up delay-1">Trusted Financial Partner Since 2006</span>
            <h1 className="hero__title fade-in-up delay-2">
              Expert Financial Guidance for Your <span className="hero__highlight">Success</span>
            </h1>
            <p className="hero__subtitle fade-in-up delay-3">
              Personalized accounting, tax preparation, and financial planning services 
              for individuals and businesses throughout Southern California and beyond.
            </p>
            <div className="hero__actions fade-in-up delay-4">
              <Link to="/contact" className="btn btn-primary btn--lg">
                Schedule Consultation
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </Link>
              <Link to="/services" className="btn btn-outline">
                Our Services
              </Link>
            </div>
          </div>
        </div>

        <div className="hero__scroll-hint">
          <span className="hero__scroll-text">Scroll to Explore</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>
        </div>
      </section>

      {/* ===== STATS BAR ===== */}
      <section className="stats">
        <div className="container">
          <div className="stats__grid">
            {stats.map((stat, i) => (
              <div key={i} className="stats__item fade-in-up" style={{ animationDelay: `${0.1 + i * 0.1}s` }}>
                <span className="stats__number">{stat.number}</span>
                <span className="stats__label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SERVICES HIGHLIGHTS ===== */}
      <section className="section services-home">
        <div className="container">
          <div className="text-center" style={{ marginBottom: '56px' }}>
            <span className="section-label">What We Do</span>
            <h2 className="section-title">Comprehensive Financial Services</h2>
            <p className="section-subtitle">
              From tax planning to business consulting, we provide the expert guidance 
              you need to make confident financial decisions.
            </p>
          </div>

          <div className="services-home__grid">
            {highlights.map((item, i) => (
              <div key={i} className="service-card fade-in-up" style={{ animationDelay: `${0.1 + i * 0.08}s` }}>
                <div className="service-card__icon">{item.icon}</div>
                <h3 className="service-card__title">{item.title}</h3>
                <p className="service-card__desc">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="text-center" style={{ marginTop: '48px' }}>
            <Link to="/services" className="btn btn-primary">
              View All Services
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </Link>
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="section why-us">
        <div className="container">
          <div className="why-us__layout">
            <div className="why-us__content">
              <span className="section-label">Why Choose Us</span>
              <h2 className="section-title">Your Success Is Our Priority</h2>
              <p className="section-subtitle" style={{ marginBottom: '32px' }}>
                We go beyond number-crunching to become a true partner in your financial journey,
                combining deep expertise with a genuine commitment to your goals.
              </p>
              <div className="why-us__points">
                <div className="why-us__point">
                  <div className="why-us__check">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <h4>Personalized Attention</h4>
                    <p>Every client receives a tailored approach that addresses their unique financial situation and goals.</p>
                  </div>
                </div>
                <div className="why-us__point">
                  <div className="why-us__check">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <h4>Proactive Planning</h4>
                    <p>We don't just look at today — we help you plan for future growth and long-term financial security.</p>
                  </div>
                </div>
                <div className="why-us__point">
                  <div className="why-us__check">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  <div>
                    <h4>Up-to-Date Expertise</h4>
                    <p>We stay current on tax laws and regulations to optimize every financial opportunity for our clients.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="why-us__visual">
              <div className="why-us__card">
                <img src="/images/logo.svg" alt="GFS" className="why-us__logo" />
                <div className="why-us__card-text">
                  <p className="why-us__quote">
                    "Our mission is to help clients maintain financial viability in the present while taking a proactive approach to achieve future goals."
                  </p>
                  <span className="why-us__author">— Vahan Gelejian, Founder and CEO</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="cta-section">
        <div className="cta-section__bg" />
        <div className="container">
          <div className="cta-section__content text-center">
            <h2 className="cta-section__title">Ready to Take Control of Your Finances?</h2>
            <p className="cta-section__text">
              Let's discuss how we can help you achieve your financial goals. 
              Schedule a free consultation today.
            </p>
            <div className="cta-section__actions">
              <Link to="/contact" className="btn btn-gold btn--lg">
                Get Started Today
              </Link>
              <a href="tel:+18183430080" className="btn btn-outline">
                Call (818) 343-0080
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
